// extracted by mini-css-extract-plugin
module.exports = {"Action":"Action__6lHxK"};